import { render, staticRenderFns } from "./TheCgCreditsBalance.vue?vue&type=template&id=64223e78&scoped=true"
import script from "./TheCgCreditsBalance.vue?vue&type=script&lang=js"
export * from "./TheCgCreditsBalance.vue?vue&type=script&lang=js"
import style0 from "./TheCgCreditsBalance.vue?vue&type=style&index=0&id=64223e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64223e78",
  null
  
)

export default component.exports